export default {"src":"/_next/static/media/permission_desk.f690a6e5.svg","height":300,"width":403,"blurWidth":0,"blurHeight":0};